<template>
    <div class="ipt">
      <input 
        :type="type" 
        :placeholder="ph" 
        :value="value" 
        @input="handleIpt" 
        :disabled="disabled" 
        :maxlength="limitLen" 
        v-if="limitLen" 
        @focus="focus" 
        @blur="blur"
        :class="warning ? 'error' : ''"
      />
      <input 
        :type="type" 
        :placeholder="ph" 
        :value="value" 
        @input="handleIpt" 
        :disabled="disabled" 
        v-else 
        @focus="focus" 
        @blur="blur" 
        :class="warning ? 'error' : ''"
      />
      <slot/>
    </div>
</template>

<script>
export default {
    props: {
      value: String,
      ph: String,
      showTips: Boolean,
      limitLen: {
        type: Number,
        default: 0
      },
      warning: {
        type: String,
        defult: ''
      },
      type: {
        type: String,
        default: 'text'
      },
      isNumber: {
        type: Boolean,
        default: false
      },
      isPassword: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      handleIpt(e) {
        let val = e.target.value;
        if (this.isNumber) {
          val = val.replace(/[^\d]/g, '');
        }
        if (this.isPassword) {
          val = val.replace(/[^a-zA-Z0-9]/g, '');
        }
        val = val.replace(/[^\S]/g, '');
        this.$emit('input', val);
        this.$nextTick(() => {
          if (val !== e.target.value) {
            e.target.value = val;
          }
        })
        // if (this.limitLen === 0) {
        //   // 0表示不限制
        //   this.$emit('input', val);
        // if (val !== e.target.value) {
        //   e.target.value = val;
        // }
        // }else {
        //   const len = val.length;
        //   if (len > this.limitLen) {
        //     this.$emit('input', val.slice(0, this.limitLen));
        //     e.target.value = val.slice(0, this.limitLen);
        //   }else {
        //     this.$emit('input', val);
        //     if (val !== e.target.value) {
        //       e.target.value = val;
        //     }
        //   }
        // }
      },

      focus() {
        this.$emit('focus')
      },

      blur() {
        this.$emit('blur')
      }
    }
}
</script>

<style lang="scss" scoped>
.ipt {
  margin-top: 10px;
}

input {
  width: 100%;
  min-width: 150px;
  height: 40px;
  padding: 1px 10px;
  font-size: 14px;
  color: #333;
  background: #EFF2F4;
  // box-shadow: inset 0 1px 1px 0 rgba(212,212,212,0.50);
  border-radius: 6px;
  border: none;
  outline: none;
  box-sizing: border-box;
  border: 2px solid rgba(212,212,212,0.5);

  &:focus {
    padding: 0 10px;
    border: 2px solid #08A681;
  }

  &::placeholder {
    color: #9F9F9F;
  }
}

.error {
  border-color: #E51C23!important;
}

p {
  font-size: 12px;
  color: #999999;
  margin-top: 8px;
}
</style>
